import { Components, Theme } from "@mui/material";

export const MuiTab: Components<Theme>["MuiTab"] = {
  styleOverrides: {
    root: {
      // borderRadius: '1rem'
    },
  },
};
